const VARIANTS = {
  primary:
    "bg-[#C9587E] text-[#FFFCFB] hover:bg-[#AD4368] border border-[#C9587E] hover:border-[#AD4368]",
  secondary:
    "bg-transparent text-[#C9587E] hover:bg-[#C9587E] hover:text-[#FFFCFB] border border-[#C9587E]",
  cream:
    "bg-[#FAF3F2] text-[#3B2630] hover:bg-[#F7E9EC] border border-[#FAF3F2]",
};

export const CTAButton = ({
  children,
  variant = "primary",
  onClick,
  href,
  testid,
  className = "",
}) => {
  const classes = `group inline-flex items-center justify-center rounded-full px-10 md:px-14 py-5 font-body uppercase tracking-[0.25em] text-xs font-semibold transition-colors duration-500 ${VARIANTS[variant]} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={classes}
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} data-testid={testid} className={classes}>
      {children}
    </button>
  );
};
